import type { AuthConfig } from "./types";

function numEnv(value: string | undefined, defaultValue: number): number {
	if (value === undefined || value.trim() === "") {
		return defaultValue;
	}

	const parsed = parseInt(value, 10);

	return isNaN(parsed) ? defaultValue : parsed;
}

const authConfig: AuthConfig = {
	checkTokenExpirationInterval: 999999999999, // numEnv(import.meta.env.VITE_AUTH_CHECK_TOKEN_EXPIRATION_INTERVAL, 10 * 1000), // 10 seconds
	checkTokenExpirationThreshold: numEnv(
		import.meta.env.VITE_AUTH_CHECK_TOKEN_EXPIRATION_THRESHOLD,
		30 * 1000,
	), // 30 seconds
	interceptorRefreshThreshold: numEnv(
		import.meta.env.VITE_AUTH_INTERCEPTOR_REFRESH_THRESHOLD,
		20 * 1000,
	), // 30 seconds
	tabVisibilityCheckDelay: 100, // 100ms - delay before checking token when tab becomes visible
	debug: true, // import.meta.env.VITE_DEBUG_AUTH === "true", // Enable debug logging based on environment variable
};

export default authConfig;
